export enum Language {
  ENGLISH_GB = 'en-GB',
  FINNISH = 'fi',
}

export const getLanguageLabel = (language: Language): string => {
  switch (language) {
    case Language.ENGLISH_GB:
      return 'English (UK)';
    case Language.FINNISH:
      return 'Finnish';
    default:
      return language;
  }
};

export const DEFAULT_LANGUAGE = Language.ENGLISH_GB;
export const FALLBACK_LANGUAGE = Language.ENGLISH_GB;
